import moment from 'moment';
import React, {Fragment} from 'react';
import './SignatureElement.scss';

const AcknowledgementElement = (props) => {
  return (
    <Fragment>
      <div className="signature-element acknowledged">
        <div className="signed">
          <div className="signed-text">Ack</div>
        </div>
        <div>
          <b>{props.acknowledgedBy}</b> {moment(props.acknowledgedAt).format('HH:mm on MMM D, YYYY')}
          <div style={{fontSize: '0.8em', paddingTop: '10px'}}>I acknowledge that I have reviewed and fully understand
            all of the details of this form and I am comfortable appropriately executing this training experience
          </div>
          {props.ackComment && (
            <div style={{paddingTop: '10px'}}>
              <div><b>{props.acknowledgedBy}'s Notes</b></div>
              <div style={{fontSize: '0.9em', paddingTop: '10px'}}>{props.ackComment}</div>

            </div>
          )}
        </div>
      </div>

    </Fragment>
  );
};

export default AcknowledgementElement;
